import CryptoJS from 'crypto-js';

import { setGUIDHash } from './cookies';
import Cookies from 'js-cookie';

export const emailHash = (email?: string) => {
  const lowercaseEmail = email?.toLowerCase();

  if (lowercaseEmail) {
    return CryptoJS.SHA256(lowercaseEmail).toString(CryptoJS.enc.Base64);
  }

  return '';
};

interface Props {
  email: string;
  first_name?: string;
  last_name?: string;
  address?: {
    city?: string;
    country?: string;
    postalCode?: string;
    state?: string;
    street?: string;
  };
}

export const identify = ({ email: rawEmail, ...properties }: Props) => {
  const email = rawEmail?.toLowerCase();
  const hash = emailHash(email);
  const monetate_id = Cookies.get('mt.v');
  setGUIDHash(hash);
  window?.analytics?.identify(hash, {
    ...properties,
    email,
    guidh: hash,
    monetate_id,
  });
};
